import { create } from 'zustand';

export interface AuthData {
  token: string;
  platform: string;
  region: string;
  user_type: string;
}

type AuthStatus = 'idle' | 'loading' | 'success' | 'error';

interface AuthStore {
  auth: AuthData | null;
  sessionId: string | null;
  aiToken: string | null;
  refreshToken: string | null;
  authStatus: AuthStatus;
  setAuth: (auth: AuthData) => void;
  setSessionId: (sessionId: string) => void;
  setAiToken: (aiToken: string) => void;
  setRefreshToken: (refreshToken: string) => void;
  setAuthStatus: (status: AuthStatus) => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  auth: null,
  sessionId: null,
  aiToken: null,
  refreshToken: null,
  authStatus: 'idle',
  setAuth: (auth) => set({ auth }),
  setSessionId: (sessionId) => set({ sessionId }),
  setAiToken: (aiToken) => set({ aiToken }),
  setRefreshToken: (refreshToken) => set({ refreshToken }),
  setAuthStatus: (authStatus) => set({ authStatus }),
}));
